<template>
  <div class="mb-5" style="padding-bottom: 10rem">
    <div class="container mt-5" v-if="steps.one">
      <md-card class="text-center">
        <md-card-header>
          <div class="md-title">Busqueda Asegurado</div>
          <div class="md-subhead">Ingresa los datos solicitados</div>
        </md-card-header>

        <md-card-content>
          <div class="row d-flex justify-content-center">
            <div class="col-md-2">
              <md-field>
                <label>Póliza</label>
                <md-input value="60000893" disabled></md-input>
                <!-- <span v-if="errors.poliza" class="md-error">Campo requerido</span> -->
              </md-field>
            </div>

            <div class="col-md-3">
              <md-field :class="{ 'md-invalid': errors.curp }">
                <label>CURP</label>
                <md-input
                  v-model="curp"
                  minlength="10"
                  maxlength="18"
                ></md-input>
                <span v-if="errors.curp" class="md-error">{{
                  mensajeErrorCurp
                }}</span>
              </md-field>
            </div>

            <div class="col-md-2">
              <md-field :class="errorClasses.nombre">
                <label>Nombre(s)</label>
                <md-input v-model="nombre"></md-input>
                <span v-if="errors.nombre" class="md-error"
                  >Campo requerido</span
                >
              </md-field>
            </div>
            <div class="col-md-2">
              <md-field :class="errorClasses.apellidoP">
                <label>Apellido Paterno</label>
                <md-input v-model="apellidoP"></md-input>
                <span v-if="errors.apellidoP" class="md-error"
                  >Campo requerido</span
                >
              </md-field>
            </div>
            <div class="col-md-2">
              <md-field :class="errorClasses.apellidoM">
                <label>Apellido Materno</label>
                <md-input v-model="apellidoM"></md-input>
                <span v-if="errors.apellidoM" class="md-error"
                  >Campo requerido</span
                >
              </md-field>
            </div>
          </div>
        </md-card-content>
        <md-card-actions>
          <!-- <md-button style="background-color: #7890a8; color: #fff;" @click="altaShow"
                    class="md-raised col-2 m-3">Alta nueva
                </md-button> -->
          <md-button
            style="background-color: #9cc4e4; color: #586875"
            @click="searchPoliza"
            class="md-raised col-2 m-3"
            ><i class="fas fa-search mr-2"></i>Buscar
          </md-button>
        </md-card-actions>
      </md-card>
    </div>

    <div class="m-3" v-if="steps.two">
      <md-table v-model="paginatedPeople" md-card @md-selected="onSelect">
        <md-table-toolbar>
          <h1 class="md-title">Selecciona una póliza del listado:</h1>
        </md-table-toolbar>

        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          :class="getClass(item)"
          md-selectable="single"
        >
          <md-table-cell md-label="Póliza" md-sort-by="id" md-numeric>{{
            item.NUM_POLIZA
          }}</md-table-cell>
          <md-table-cell md-label="Asegurado" md-sort-by="name">{{
            item.NOMBRE_PERSONA
          }}</md-table-cell>
          <md-table-cell md-label="Ap. Paterno" md-sort-by="email">{{
            item.APELLIDO_PATERNO
          }}</md-table-cell>
          <md-table-cell md-label="Ap. Materno" md-sort-by="gender">{{
            item.APELLIDO_MATERNO
          }}</md-table-cell>
          <md-table-cell md-label="Fec. Nacimiento" md-sort-by="title">{{
            item.F_NACIMIENTO
          }}</md-table-cell>
          <md-table-cell md-label="Contratante" md-sort-by="title">{{
            item.NOMBRE
          }}</md-table-cell>
          <md-table-cell md-label="Fec. Ini. Vigencia" md-sort-by="title">{{
            item.F_INI_VIGENCIA
          }}</md-table-cell>
          <md-table-cell md-label="Fec. Fin Vigencia" md-sort-by="title">{{
            item.F_FIN_VIGENCIA
          }}</md-table-cell>
          <md-table-cell md-label="Estatus" md-sort-by="title">{{
            item.SIT_INCISO_POL
          }}</md-table-cell>
          <md-table-cell md-label="Filial/Subcontratante" md-sort-by="title">{{
            item.NOM_FILIAL
          }}</md-table-cell>
          <md-table-cell md-label="Certificado" md-sort-by="title">{{
            item.NUM_CERTIFICADO
          }}</md-table-cell>
          <md-table-cell md-label="Participacion" md-sort-by="title">{{
            item.T_ASEG
          }}</md-table-cell>
          <md-table-cell md-label="Producto" md-sort-by="title">{{
            item.NOM_PRODUCTO
          }}</md-table-cell>
          <md-table-cell md-label="Nivel Hospitalario" md-sort-by="title">{{
            item.NIVEL_HOSP
          }}</md-table-cell>
        </md-table-row>
      </md-table>

      <div class="pagination-controls">
        <md-button
          class="md-raised m-3 float-right btn-pagination"
          @click="prevPage"
          :disabled="currentPage === 1"
          >Anterior</md-button
        >
        <span style="color: #586875"
          >Página {{ currentPage }} de {{ totalPages }}</span
        >
        <md-button
          class="md-raised m-3 float-right btn-pagination"
          @click="nextPage"
          :disabled="currentPage === totalPages"
          >Siguiente</md-button
        >
      </div>

      <md-button
        style="background: #9cc4e4; color: #586875"
        class="md-raised col-2 m-3 float-right"
        @click="selectPoliza"
      >
        <i class="fas fa-check mr-2"></i>Seleccionar
      </md-button>
    </div>
    <ValidarDatos
      v-if="steps.three"
      :continuarRegistro="continuarRegistro"
      :persona.sync="selected"
      :step="btnValidacion"
      ref="validarDatosComponent"
    />

    <Tabs
      v-if="steps.four"
      :catalogoLesion.sync="catalogoLesion"
      :catalogoEspacio.sync="catalogoEspacio"
      :catalogoCuerpo.sync="catalogoCuerpo"
      :catalogoAccidente.sync="catalogoAccidente"
      :catalogoUbicacion.sync="catalogoUbicacion"
      :catalogoHospitales.sync="catalogoHospitales"
      :catalogoEscuelas.sync="catalogoEscuelas"
      :catalogoICD.sync="catalogoICD"
      :catalogoCTP.sync="catalogoCTP"
      :icdClave="icdClave"
      :icdDesc="icdDesc"
      :ctpClave="ctpClave"
      :ctpDesc="ctpDesc"
      :methodCTP="CTP"
      :methodICD="ICD"
      @dataTabs="handleDataTabs"
      @update-icd-clave="updateIcdClave"
      @update-icd-desc="updateIcdDesc"
      :textoBoton="'Generar Aviso'"
    />
    <Loading :isLoading="isLoading" />
    <SuccessModal
      :showDialog.sync="showSuccess"
      :mensaje="mensajeSuccess"
      :reloadPage="reloadPage"
    />
    <ErrorModal :showDialog.sync="showError" :mensaje="mensajeError" />
    <AlertModal :showDialog.sync="showAlert" :mensaje="mensajeAlert" />
  </div>
</template>

<script>
import ValidarDatos from "./validarDatos.vue";
import Tabs from "./tabs.vue";
import Loading from "./Tools/loading.vue";
import SuccessModal from "./Modals/successModal.vue";
import ErrorModal from "./Modals/errorModal.vue";
import AlertModal from "./Modals/alertModal.vue";

export default {
  components: {
    ValidarDatos,
    Tabs,
    Loading,
    SuccessModal,
    ErrorModal,
    AlertModal,
  },
  data() {
    return {
      userId: localStorage.getItem("userId"),
      curp: "",
      mensajeErrorCurp: "",
      reloadPage: false,
      showSuccess: false,
      showError: false,
      showAlert: false,
      isLoading: false,
      btnValidacion: true,
      showAlta: false,
      steps: {
        one: true,
        two: false,
        three: false,
        four: false,
      },
      data: "",
      selected: {},
      dataRecibida: {},
      currentPage: 1,
      perPage: 5,
      icdClave: "",
      ctpClave: "",
      icdDesc: "",
      ctpDesc: "",
      folioISEP: "",
      //Catalogos
      catalogoLesion: [],
      catalogoEspacio: [],
      catalogoCuerpo: [],
      catalogoAccidente: [],
      catalogoUbicacion: [],
      catalogoHospitales: [],
      catalogoEscuelas: [],
      catalogoEdoCivil: [],
      catalogoSexo: [],
      catalogoICD: [],
      catalogoCTP: [],
      //busqueda poliza
      poliza: "",
      nombre: "",
      apellidoP: "",
      apellidoM: "",
      errors: {
        poliza: false,
        nombre: false,
        apellidoP: false,
        apellidoM: false,
        curp: false,
      },
      aseguradosList: [],
      //alertas
      mensajeAlert: "",
      mensajeError: "",
      mensajeSuccess: "",
      pNumeroReclamacion: "",
    };
  },
  methods: {
    updateIcdClave(value) {
      this.icdClave = value;
    },
    validarCurp() {
      const curpCompletoRegex = /^[A-Z]{4}\d{6}[HM][A-Z]{5}\d{2}$/;

      // Limitar el CURP a un máximo de 18 caracteres
      if (this.curp.length > 18) {
        this.curp = this.curp.substring(0, 18);
      }

      // Si el campo está vacío, no mostrar el mensaje de error
      if (this.curp === "") {
        this.errors.curp = false;
        this.mensajeErrorCurp = "";
        return; // Detener la validación si el campo está vacío
      }

      // Validar si tiene 10 caracteres (se acepta) o 18 (requiere formato)
      if (this.curp.length === 18) {
        // Verificar si el CURP de 18 caracteres tiene el formato correcto
        if (!curpCompletoRegex.test(this.curp)) {
          this.errors.curp = true;
          this.mensajeErrorCurp = "El CURP no tiene un formato válido.";
        } else {
          this.errors.curp = false;
          this.mensajeErrorCurp = "";
        }
      } else if (this.curp.length === 10) {
        // Si tiene exactamente 10 caracteres, se acepta sin validar el formato
        this.errors.curp = false;
        this.mensajeErrorCurp = "";
      } else {
        // Si tiene menos de 10 o entre 10 y 18 caracteres, no es válido
        this.errors.curp = true;
        this.mensajeErrorCurp = "El CURP debe tener 10 o 18 caracteres.";
      }
    },

    updateIcdDesc(value) {
      this.icdDesc = value;
    },
    async handleDataTabs(data) {
      this.dataRecibida = data;
      this.$set(data, "selectedPerson", this.selected);
      console.log("data",data);
      console.log("datos de poliza");
      console.log(this.dataRecibida);

      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      // Validación de campos
      const camposRequeridos = {
        "Fecha de registro": data.dateRegistro,
        "Fecha de 1er. gasto": data.primerGasto,
        "Fecha de 1er. reclamación": data.primerReclamacion,
        "Hora de Registro": data.horaRegistro,
        "Descripcion de registro": data.descripcionRegistro,
        "Seguro de la Escuela": data.seguro,
        "Clave de la Escuela": data.clave,
        "Nombre de la Escuela": data.nombreEscuela,
        "Nivel de la Escuela": data.nivel,
        "Municipio de la Escuela": data.municipio,
        Ubicación: data.ubicacion,
        Espacio: data.espacio,
        Accidente: data.accidente,
        Lesion: data.lesion,
        Cuerpo: data.cuerpo,
        "Nombre del acompañante": data.nombre,
        "Apellido paterno  del acompañante": data.apellidoPaterno,
        "Apellido materno  del acompañante": data.apellidoMaterno,
        "Parentesco  del acompañante": data.parentesco,
        "Teléfono  del acompañante": data.telefono,
        "Correo  del acompañante": data.correo,
        Clinica: data.selectedHospital,
        ICD: data.ICD,
        CTP: data.CTP,
        Observaciones: data.observaciones,
        Autorizado: data.autorizado,
        "Fecha de Consulta": data.dateConsulta,
      };

      for (const [campo, valor] of Object.entries(camposRequeridos)) {
        if (
          !valor ||
          (typeof valor === "object" && Object.keys(valor).length === 0)
        ) {
          this.showError = true;
          this.mensajeError = `El campo ${campo} es requerido.`;
          setTimeout(() => {
            this.showError = false;
          }, 3000);
          return;
        }
      }
      if (data.telefono.length > 10 || data.telefono.length < 10) {
        this.showError = true;
        this.mensajeError = `El campo Telefono del acompañante es invalido.`;
        return;
      }

      if (!emailPattern.test(data.correo)) {
        this.mensajeError =
          "El Correo  del acompañante no tiene un formato válido";
        this.showError = true;
        return;
      }

      this.isLoading = true;
      const payload = {
        metodo: "GETPDFISEP",
        data: {
          NombreAsegurado:
            `${this.selected.NOMBRE_PERSONA} ${this.selected.APELLIDO_PATERNO} ${this.selected.APELLIDO_MATERNO}`.trim(),
          Grado: "",
          FechaNacimiento: this.selected.FNacimiento || "",
          FechaAccidente: this.dataRecibida.dateRegistro,
          HoraAccidente: this.dataRecibida.horaRegistro,
          LugarAccidente: this.dataRecibida.ubicacion,
          DescripcionAccidente: this.dataRecibida.descripcionRegistro,
          LesionAccidente: this.dataRecibida.lesion,
          ClaveInstituto: this.dataRecibida.clave,
          TelefonoInstituto: "",
          NonbreInstituto: this.dataRecibida.nombreEscuela,
          NombreHospital: this.dataRecibida.selectedHospital.NOMBRE,
          DireccionHospital: "",
          TelefonoHospital: "",
          MedicoHospital: "",
          FechaHospital: this.dataRecibida.dateConsulta,
          MunicipioHospital: "",
          NombreAcompanante:
            `${this.dataRecibida.nombre} ${this.dataRecibida.apellidoPaterno} ${this.dataRecibida.apellidoMaterno}`.trim(),
          DireccionAcompanante: "",
          TelefonoAcompanante: this.dataRecibida.telefono,
          ParentescoAcompanante: this.dataRecibida.parentesco,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        console.log(response);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res.data);
          this.showError = false;
          await this.informacionSiniestro(res.data, data);
        } else {
          this.isLoading = false;
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        }
      } catch (error) {
        console.log(error);
        this.showError = true;
        this.mensajeError = "Hubo un error al generar el PDF";
        this.isLoading = false;
        setTimeout(() => {
          this.showError = false;
        }, 5000);
      }
      this.isLoading = false;
    },
    async generaFolio(base64, data) {
      // this.isLoading = true
      const payload = {
        metodo: "ALTAFOLIOISEP",
        data: {
          IdAgente: "10909",
          // IdAgente: localStorage.getItem('profileId'),
          NumPoliza: this.selected.NUM_POLIZA,
          TipoPersona: "1",
          Nombre: this.selected.NOMBRE_PERSONA,
          ApellidoMaterno: this.selected.APELLIDO_MATERNO,
          ApellidoPaterno: this.selected.APELLIDO_PATERNO,
          AnioReporte: new Date().getFullYear(),
          NumeroReclamacion: this.pNumeroReclamacion,
          Requisitos: [
            {
              idRequisito: 518,
              base64: base64,
              nombre: `documento_${this.selected.NOMBRE_PERSONA}`,
              contentType: "application/pdf",
              extension: ".pdf",
            },
          ],
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
          this.folioISEP = res.folio;
          this.showError = false;
          this.showSuccess = true;
          this.mensajeSuccess = `Número de folio generado: <strong>${res.folio}</strong>`;
          this.reloadPage = true;
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 10000);
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      // this.isLoading = false
    },
    async guardaDatosProceso(data, folio, reporte) {
      const date = new Date();
      const options = { day: "2-digit", month: "2-digit", year: "numeric" };
      const formattedDate = date.toLocaleDateString("es-ES", options);
      const payload = {
        metodo: "GUARDADATOSPROCESOISEP",
        data: {
          pAutorizado: data.autorizado
            ? data.autorizado == "Si"
              ? true
              : false
            : true,
          pFechaCaptura: data.dateRegistro
            ? this.formatFecha(data.dateRegistro)
            : formattedDate, //fecha actual solo cuando es registro nuevo
          pFechaOcurrido: data.dateRegistro
            ? this.formatFecha(data.dateRegistro)
            : formattedDate,
          pHoraOcurrido: data.horaRegistro || "12:00:00",
          pNombre: data.selectedPerson.NOMBRE_PERSONA,
          pApellidoPaterno: data.selectedPerson.APELLIDO_PATERNO,
          pApellidoMaterno: data.selectedPerson.APELLIDO_MATERNO,
          pSexo: data.selectedPerson.CVE_SEXO == "F" ? "Femenino" : "Masculino",
          pNumeroPoliza: "60000893",
          pFechaNacimiento: data.selectedPerson.F_NACIMIENTO.split(" ")[0] || "",
          /*pHospital: data.selectedHospital.NOMBRE
            ? data.selectedHospital.NOMBRE
            : "",*/
          pHospital: data.selectedHospital.ID_PREST_SERV
            ? data.selectedHospital.ID_PREST_SERV
            : "",
          pNombreHospital: data.selectedHospital.NOMBRE
            ? data.selectedHospital.NOMBRE
            : "",
          pEstadoHospital: "",
          pTipoLesion: data.lesion ? data.lesion : "",
          pParteCuerpo: data.cuerpo ? data.cuerpo : "",
          pTipoAccidente: data.accidente ? data.accidente : "",
          pDescripcionAccidente: data.descripcionRegistro
            ? data.descripcionRegistro
            : "",
          pAcompanante: data.nombre
            ? `${data.nombre} ${data.apellidoPaterno} ${data.apellidoMaterno}`.trim()
            : "",
          pContacto: data.telefono ? data.telefono : "",
          pParentescoContancto: data.parentesco ? data.parentesco : "",
          pNivelEducativo: data.nivel ? data.nivel : "",
          pClaveInstitucion: data.clave ? data.clave : "",
          pNombreInstitucion: data.nombreEscuela ? data.nombreEscuela : "",
          pMunicipio: data.municipio ? data.municipio : "",
          pCosto: "",
          pNumeroReporteSis: reporte, //Se manda cuando ya existe el asegurado
          pNumeroFolioSis: folio, //Se manda cuando el asegurado es nuevo
          pEstatus: "Alta", //Alta es para los que ya existen asegurado y Pendiente es para el asegurado nuevo
          pEstadoCivil: data.civil ? data.civil : "",
          pNumeroFolioInnova: this.folioISEP,
          pUsuarioAlta: this.userId,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 10000);
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoading = false;
    },
    async searchPoliza() {
      await this.CTP();
      await this.ICD();
      this.showError = false;
      this.mensajeError = "";
      this.showAlert = false;

      // Validar si el CURP tiene algo
      if (this.curp && this.curp.length > 0) {
        const curpCompletoRegex = /^[A-Z]{4}\d{6}[HM][A-Z]{5}\d{2}$/;

        // Si el CURP tiene 18 caracteres, validamos el formato
        /*if (this.curp.length === 18) {
          const isCurpValid = curpCompletoRegex.test(this.curp);
          if (!isCurpValid) {
            this.errors.curp = true;
            this.mensajeErrorCurp = "El CURP no tiene un formato válido.";
            return; // Detener el flujo si el CURP no es válido
          } else {
            this.errors.curp = false;
            this.mensajeErrorCurp = "";
          }
        }*/

        // Si el CURP tiene 10 caracteres, se acepta sin validar el formato
        if (this.curp.length === 10) {
          this.errors.curp = false;
          this.mensajeErrorCurp = "";
        }

        // Si tiene una longitud diferente de 10 o 18 caracteres, es inválido
        else if(this.curp.length < 10 || this.curp.length > 18) {
          this.errors.curp = true;
          this.mensajeErrorCurp = "El CURP debe tener 10 o 18 caracteres.";
          return;
        }

        // Si CURP es válido, el campo nombre no será requerido
        this.errors.nombre = false;
      } else {
        // Si el CURP está vacío, validar que el campo Nombre sea requerido
        this.errors.nombre = this.nombre === "";
        if (this.errors.nombre) {
          this.showError = true;
          this.mensajeError =
            "El campo Nombre es requerido si no se ingresa CURP.";
          return; // Detener si el nombre está vacío y no se ha ingresado CURP
        }
      }

      this.isLoading = true;
      const payload = {
        metodo: "OBTIENEDATOSPOLIZAISEP",
        data: {
          NumeroPoliza: "60000893",
          Nombre: this.nombre, // Si CURP tiene algo, este campo no es obligatorio
          ApellidoPaterno: this.apellidoP,
          ApellidoMaterno: this.apellidoM,
          NumeroRenovacion: null,
          FechaOcurrido: null,
          Curp: this.curp, // Se valida y envía el CURP si es válido
        },
      };

      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);

          this.showError = false;
          if (res.length >= 1) {
            this.steps.one = false;
            this.steps.two = true;
            this.aseguradosList.push(...res);
            this.selected = null;
          } else if (res == "") {
            this.showAlert = true;
            this.mensajeAlert = `No se encontraron resultados para la búsqueda: ${this.nombre} ${this.apellidoP} ${this.apellidoM}`;
            setTimeout(() => {
              this.showAlert = false;
            }, 6000);
          } else {
            this.showAlert = true;
            this.mensajeAlert = res.ALERTA;
            setTimeout(() => {
              this.showAlert = false;
            }, 6000);
          }
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 6000);
        }
      } catch (error) {
        console.log(error);
        this.showError = true;
        this.mensajeError = "Hubo un error en la búsqueda.";
        setTimeout(() => {
          this.showError = false;
        }, 6000);
      }
      this.isLoading = false;
      this.mensajeErrorCurp = "";
    },

    selectPoliza() {
      if (this.selected == {} || this.selected == null) {
        this.showAlert = true;
        this.mensajeAlert = "Debes selecionar una póliza del listado.";
        return;
      }
      if (this.selected.SIT_INCISO_POL != "VIGENTE") {
        this.showAlert = true;
        this.mensajeAlert = "La póliza no es vigente.";
        return;
      }
      this.showAlert = false;
      this.steps.two = false;
      this.steps.three = true;
    },
    continuarRegistro() {
      this.steps.three = true;
      this.steps.four = true;
      this.btnValidacion = false;
      this.$nextTick(() => {
        // Scroll hacia el nuevo componente
        const componente = this.$refs.validarDatosComponent.$el;
        if (componente) {
          const pageHeight = document.documentElement.scrollHeight;
          window.scrollTo({ top: pageHeight, behavior: "smooth" });
        }
      });
    },
    async informacionSiniestro(base64, data) {
      console.log("data de preceso", data)
      console.log("data de preceso recibida", this.dataRecibida)

      const payload = {
        metodo: "INFORMACIONSINIESTROISEP",
        data: {
          pAnioReporte: new Date().getFullYear(),
          pFechaOcurrido: this.dataRecibida.dateRegistro,
          pFechaPrimerGto: this.dataRecibida.primerGasto,
          pFechaPrimerRecl: this.dataRecibida.primerReclamacion,
          pNumeroPoliza: this.selected.NUM_POLIZA,
          pIdInciso: this.selected.ID_INCISO,
          pCveIcd: this.dataRecibida.ICD.CVEL_ICD,
          pCveCPT: this.dataRecibida.CTP.CVEL_CPT,
          pIdUsuarioReg: "INNOVA01", //FIJO por lo mientras
          pIdPrestadorServicio: this.dataRecibida.selectedHospital.ID_PREST_SERV,
          pSitSiniestro: this.dataRecibida.autorizado === "Si" ? 1 : 0,
        },
      };
      console.log(payload);

      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
          this.pNumeroReclamacion = res.pNumeroReclamacion;
          if (res.pNumeroReclamacion) {
            await this.generaFolio(base64, data);
            await this.guardaDatosProceso(data, "", res.pNumeroReclamacion);
          
          } else {
            this.showError = true;
            this.mensajeError = "Error al generar numero de reclamación.";
            setTimeout(() => {
              this.showError = false;
            }, 6000);
          }
        } else {
          let error = this.$store.getters.getDataRaw.errorMessage;
          this.showError = true;
          this.mensajeError = error;
          setTimeout(() => {
            this.showError = false;
          }, 6000);
          console.log(error);
        }
      } catch (error) {
        this.showError = true;
        this.mensajeError = error;
        setTimeout(() => {
          this.showError = false;
        }, 6000);
        console.log(error);
      }
    },
    formatFecha(fecha) {
      const date = new Date(fecha);
      const dia = String(date.getUTCDate()).padStart(2, "0");
      const mes = String(date.getUTCMonth() + 1).padStart(2, "0"); // Los meses en JavaScript van de 0 a 11
      const anio = date.getUTCFullYear();

      return `${dia}/${mes}/${anio}`;
    },
    //estilos y paginador
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    getClass: ({ id }) => ({
      "md-primary": id != "",
    }),
    getClassCTP: ({ id }) => ({
      "md-primary": id != 0,
    }),
    getClassICD: ({ id }) => ({
      "md-primary": id != 0,
    }),
    onSelect(item) {
      console.log(item);
      this.selected = item;
    },
    //catalogos
    async lesion() {
      const payload = {
        metodo: "CATALOGOLESIONISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoLesion = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async espacio() {
      const payload = {
        metodo: "CATALOGOESPACIOISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoEspacio = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async cuerpo() {
      const payload = {
        metodo: "CATALOGOCUERPOISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoCuerpo = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async accidente() {
      const payload = {
        metodo: "CATALOGOACCIDENTEISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoAccidente = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async ubicacion() {
      const payload = {
        metodo: "CATALOGOUBICACIONISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoUbicacion = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async escuelas() {
      const payload = {
        metodo: "CATALOGOESCUELASISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);

          this.catalogoEscuelas = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async hospitales() {
      const payload = {
        metodo: "CATALOGOHOSPITALESISEP",
        data: {},
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoHospitales = res;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async CTP() {
      const payload = {
        metodo: "CATALOGOCTPISEP",
        data: {
          pCvel_CPT: this.ctpClave || null,
          pDesc_CPT: this.ctpDesc || null,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoCTP = res;
          console.log(res);
          if (res.length <= 0) {
            this.showAlert = true;
            this.mensajeAlert = "No se encontro información para CTP.";
            setTimeout(() => {
              this.showAlert = false;
            }, 5000);
          }
        } else {
          this.showError = true;
          this.mensajeError = "Hubo un error al consultar CTP";
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
    async ICD() {
      const payload = {
        metodo: "CATALOGOICDISEP",
        data: {
          pCvel_ICD: this.icdClave || null,
          pDESC_ICD: this.icdClave != "" ? this.icdDesc : null,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
          this.catalogoICD = res;
          if (res.length <= 0) {
            this.showAlert = true;
            this.mensajeAlert = "No se encontro información para ICD.";
            setTimeout(() => {
              this.showAlert = false;
            }, 5000);
          }
        } else {
          this.showError = true;
          this.mensajeError = "Hubo un error al consultar ICD.";
          setTimeout(() => {
            this.showError = false;
          }, 5000);
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
    },
  },
  computed: {
    paginatedPeople() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.aseguradosList.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.aseguradosList.length / this.perPage);
    },
    errorClasses() {
      return {
        // poliza: this.errors.poliza ? 'md-invalid' : '',
        nombre: this.errors.nombre ? "md-invalid" : "",
        // apellidoP: this.errors.apellidoP ? 'md-invalid' : '',
        // apellidoM: this.errors.apellidoM ? 'md-invalid' : ''
      };
    },
  },
  async mounted() {
    console.log("user", this.userId);
    setTimeout(async () => {
      await this.lesion();
      await this.espacio();
      await this.cuerpo();
      await this.accidente();
      await this.ubicacion();
      await this.hospitales();
      await this.escuelas();
    }, 2000);
  },
};
</script>

<style>
.btn-pagination {
  background: #f26c4f !important;
  color: white !important;
  font-size: 12px !important;
}
.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
}

.pagination-controls button {
  margin: 0 10px;
}
.md-table + .md-table {
  margin-top: 16px;
}
.md-field.md-has-value .md-required,
.md-field.md-is-focused .md-required {
  transform: translateY(-1.5em); /* Posición ajustada */
  font-size: 12px; /* Tamaño más pequeño para el label al estar activo */
}

.md-field .md-required {
  position: absolute; /* Coloca el label en una posición absoluta */
  top: -0.1em; /* Ajusta la posición hacia arriba */
  left: 0;
  font-size: 12px; /* Tamaño inicial más grande */
  transition: all 0.2s ease-in-out; /* Animación suave */
  pointer-events: none; /* Evita que el label interrumpa el clic en el input */
}
</style>
